import React, {useState} from 'react';
import s from '../PaperworkList.module.css';
import menuArrow from '../../../assets/img/icons/downward-arrow 1.svg';
import receipt from '../../../assets/img/icons/paperworkList/carbon_receipt.svg';
import blank from '../../../assets/img/icons/paperworkList/mingcute_bank-card-fill.svg';
import solar from '../../../assets/img/icons/paperworkList/solar_wallet-money-bold.svg';
import TableFullViewProductEl from '../../../Components/TableCommonDirectory/TableElements/TableFullViewProductEl';
import {OrderInPaperworkType} from '../../../types/TypesDepotPaperwork';
import PaperworkTableActions from './PaperworkTableActions';
import ClientInfoPopup from '../../MyTeam/Components/ClientInfoPopup/ClientInfoPopup';
import {useTranslation} from 'react-i18next';
import {
	useCreateReceiptMutation,
	useCreateReturnReceiptMutation,
	usePrintReceiptMutation,
} from '../../../redux/activitiesApi';
import {handleApiCall} from '../../../assets/utils/utils';
import {orderStatusTranslate} from '../../../assets/utils/translatersFunc';
import {CashierType} from '../../../types/CashierSliceStateType';
import {toast} from 'react-toastify';
type Props = {
	order: OrderInPaperworkType;
	currentCashier: CashierType | null;
};
const PaperworkListTableElement: React.FC<Props> = ({
	order,
	currentCashier,
}) => {
	const [open, setOpen] = useState(false);
	const [clientInfo, setClientInfo] = useState<number | null>(null);
	const {t} = useTranslation();

	const [print] = usePrintReceiptMutation();
	const [create] = useCreateReceiptMutation();
	const [createReturn] = useCreateReturnReceiptMutation();

	const handleClickUser = (id: number) => {
		setClientInfo(id);
	};
	const handleClickReceipt = async () => {
		const id = order.receipt_id;
		if (id === undefined) return;
		if (id === null) {
			currentCashier &&
				(await handleApiCall({
					apiCall: () =>
						create({
							order_id: +order.id,
							cashier_id: currentCashier.cashier_id,
							shift_id: currentCashier.shift_id,
						}),

					onSuccess: (data) => {
						if (data.approve) {
							toast.success(data.message.textmsg);
						}
					},
					onError: (error) => {
						toast.error(error);
					},
				}));
		} else {
			currentCashier &&
				(await handleApiCall({
					apiCall: () =>
						print({
							order_id: +order.id,
							cashier_id: currentCashier.cashier_id,
							receipt_id: +id,
						}),

					onSuccess: (data) => {
						if (data.approve) {
							toast.success(data.message.textmsg);
						}
					},
					onError: (error) => {
						toast.error(error);
					},
				}));
		}
	};
	const handleClickReturnReceipt = async () => {
		const id = order.return_receipt_id;
		if (id === undefined) return;
		if (id === null) {
			currentCashier &&
				(await handleApiCall({
					apiCall: () =>
						createReturn({
							order_id: +order.id,
							shift_id: currentCashier.shift_id,
						}),

					onSuccess: (data) => {
						if (data.approve) {
							toast.success(data.message.textmsg);
						}
					},
					onError: (error) => {
						toast.error(error);
					},
				}));
		} else {
			currentCashier &&
				(await handleApiCall({
					apiCall: () =>
						print({
							order_id: +order.id,
							cashier_id: currentCashier.cashier_id,
							receipt_id: +id, // Используем return_receipt_id как receipt_id для печати
						}),

					onSuccess: (data) => {
						if (data.approve) {
							toast.success(data.message.textmsg);
						}
					},
					onError: (error) => {
						toast.error(error);
					},
				}));
		}
	};
	return (
		<>
			<div className={`${s.tableRowPaperwork}`}>
				<div className={s.tableColumn}>
					<img
						role={'button'}
						tabIndex={0}
						onClick={() => setOpen(!open)}
						style={{transform: !open ? 'rotate(180deg)' : ''}}
						src={menuArrow}
						alt="arrow"
					/>
				</div>
				<div className={s.tableColumn}>{order.id}</div>
				<div className={s.tableColumn}>{order.order_date}</div>
				<button
					className={s.tableColumn}
					onClick={() => handleClickUser(+order.user_id)}
				>
					{order.name}, {order.contract}
				</button>
				<div
					className={s.tableColumn}
					title={t('Фіскалізація або Друк фіскального чека')}
				>
					<button onClick={handleClickReceipt}>
						<img src={receipt} alt="receipt" />
					</button>
				</div>
				<div
					className={s.tableColumn}
					title={
						order.receipt_id === null
							? t('Кнопка неактивна - спочатку потрібно створити чек')
							: order.return_receipt_id === null
								? t('Відміна фіскалізації')
								: t('Друк повернення фіскального чека')
					}
				>
					<button
						onClick={handleClickReturnReceipt}
						disabled={order.receipt_id === null}
						style={{
							opacity: order.receipt_id === null ? 0.5 : 1,
							cursor: order.receipt_id === null ? 'not-allowed' : 'pointer',
						}}
					>
						<img src={receipt} alt="receipt" />
					</button>
				</div>
				<div className={s.tableColumn}>
					{order.payment_method === 'card' && <img src={blank} alt="blank" />}
					{order.payment_method === 'cash' && <img src={solar} alt="solar" />}
				</div>
				<div className={s.tableColumn}>
					{orderStatusTranslate(order.status)}
				</div>
				<PaperworkTableActions order={order} />
			</div>
			{open && (
				<div className={s.hiddenInfo}>
					<TableFullViewProductEl order={order} active={open} />
				</div>
			)}
			{clientInfo !== null && clientInfo !== 0 && (
				<ClientInfoPopup
					clientInfo={clientInfo}
					setClientInfo={setClientInfo}
				/>
			)}
		</>
	);
};

export default PaperworkListTableElement;
